// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"ErrorPage_componentStyle__S3zsp","errorCode":"ErrorPage_errorCode__KfsxV","errorText":"ErrorPage_errorText__l8g6D"};